<div class="row signup-flow select-offering plans-container">
    <div class="plans-header">
      <span class="welcome-msg">
        Welcome to {{appName}}, {{org?.displayName}}
      </span>
      <span class="choose-plan">
        <p class="without-margin">Choose the plan </p>
        <p class="without-margin">that fits your needs</p>
      </span>
      <div class="goto-compare-plan">
        <span> After your free trial concludes your workspace will be downgraded to <a href="https://mode.com/compare-plans" target="blank">{{appName}} Free</a>. </span>
      </div>
    </div>
    <div class="plans">
        <ng-container *ngIf="(hideFreePlan$ | async) === false || (isUpgradePlansFlow && (hideFreePlan$ | async))">
        <mode-free-plan [isUpgradePlansFlow]="isUpgradePlansFlow"></mode-free-plan>
        </ng-container>
        <mode-team-plan [isUpgradePlansFlow]="isUpgradePlansFlow"></mode-team-plan>
        <mode-business-plan [isUpgradePlansFlow]="isUpgradePlansFlow"></mode-business-plan>
        <mode-enterprise-plan [isUpgradePlansFlow]="isUpgradePlansFlow"></mode-enterprise-plan>
    </div>
    <div class="learn-more">
      <span> Want to learn more? Watch a
        <a class="learn-more-cta" target="_blank" data-method="get" href="/signup/plans/product">product tour</a> or
        <a class="learn-more-cta" rel="nofollow" data-method="post" href="/signup/plans/book_call">
          <mode-calendly-popup-button ng-version="16.0.6">speak with a product specialist.</mode-calendly-popup-button>
        </a>
      </span>
    </div>
    <div class="compare-plans-header-container compare-plans-header-container-no-credit-card">
      <span class="compare-plans-header">
          Compare plan features
        <mode-capra-icon class="plans-detail-toggle" [icon]="planDetailsVisible ? 'icon-chevron-up' : 'icon-chevron-down'" (click)="this.planDetailsVisible = !this.planDetailsVisible" id="toggle-btn" width="24px" height="24px"></mode-capra-icon>
      </span>
   </div>
    <div *ngIf="planDetailsVisible" class="plans-detail-container" id="plan-details">
      <div class="plans-header-container">
        <div class="plans-header" [ngClass]="{'hide-free-plan': (!isUpgradePlansFlow && (hideFreePlan$ | async))}">
         <div *ngIf="((hideFreePlan$ | async) === false || (isUpgradePlansFlow && (hideFreePlan$ | async)))">
          <div class="plan-name-container">
            <span class="plan-name">Free</span>
            <div *ngIf="!isUpgradePlansFlow">
                <button class="btn plan-btn btn-style details-btn" (click)="onButtonClick()">Create a free workspace</button>
            </div>
            <div *ngIf="isUpgradePlansFlow">
              <button class="btn plan-btn btn-style details-btn" [ngClass]="{'business dark-thame': (isUpgradePlansFlow)}" (click)="goBack()">Back to my free workspace</button>
            </div>
          </div>
         </div>
          <div class="plan-name-container">
            <span class="plan-name">Team</span>
            <div *ngIf="!isUpgradePlansFlow">
                <button class="btn plan-btn btn-style details-btn" (click)="onButtonClick('team')">{{buttonLabel}}</button>
            </div>
            <div *ngIf="isUpgradePlansFlow">
              <mode-calendly-popup-button
                  class="btn plan-btn btn-style details-btn"
                >
                {{ buttonLabel }}
              </mode-calendly-popup-button>
            </div>
          </div>
          <div class="plan-name-container">
            <span class="plan-name">Pro</span>
            <div *ngIf="!isUpgradePlansFlow">
              <button class="btn plan-btn btn-style details-btn business dark-thame" (click)="onButtonClick('business')">{{ buttonLabel }}</button>
            </div>
            <div *ngIf="isUpgradePlansFlow">
              <mode-calendly-popup-button
                  class="btn plan-btn btn-style details-btn"
                >
                {{ buttonLabel }}
              </mode-calendly-popup-button>
            </div>
          </div>
          <div class="plan-name-container">
            <span class="plan-name">Enterprise</span>
            <div *ngIf="!isUpgradePlansFlow">
              <button class="btn plan-btn btn-style details-btn" (click)="onButtonClick('enterprise')">{{ buttonLabel }}</button>
              </div>
            <div *ngIf="isUpgradePlansFlow">
              <mode-calendly-popup-button
                  class="btn plan-btn btn-style details-btn"
                >
                {{ buttonLabel }}
              </mode-calendly-popup-button>
            </div>
          </div>
        </div>
      </div>
      <div class="details-container">
        <div class="details">
          <div class="plans-dtl-item"[ngClass]="{'hide-free-plan': (!isUpgradePlansFlow && (hideFreePlan$ | async))}">
            <div class="dtl-item-container first-col">
              <ng-container *ngFor="let feature of features">
                <span class="dtl-item tbl-side-desc" [ngClass]="feature.class">{{ feature.name }}</span>
              </ng-container>
            </div>
            <div class="dtl-item-container" *ngFor="let item of planDetails.slice((!isUpgradePlansFlow && (hideFreePlan$ | async)) ? 1 : 0)">
                <ng-container *ngFor="let status of item.status">
                  <ng-container *ngIf="status  !== true && status !== false">
                    <ng-container *ngIf="status === '+ Edge environment'">
                      <span class="dtl-item item-state desc weight-600">
                        {{status}}
                      </span>
                    </ng-container>
                    <ng-container *ngIf="status !== '+ Edge environment'">
                      <span class="dtl-item item-state desc">
                        {{status}}
                      </span>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="status === true">
                    <span class="dtl-item item-state">
                      <mode-capra-icon icon="icon-check" class="capra-check-icon"></mode-capra-icon>
                    </span>
                  </ng-container>
                  <ng-container *ngIf="status === false">
                    <span class="dtl-item item-state empty-cell">
                    </span>
                  </ng-container>
                </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

